import { ANSWER_MESSAGE, FrameWorkChange, FrameWorkGetPrimaryColorButton, FrameWorkGetSecundaryColorButton, FrameWorkHideAlert, FrameWorkMessageAceptCancel, FrameWorkMessageErrorAlert, FrameWorkMessageSuccessAlert, FrameWorkSimpleMessageState, OrdenExpressGetCurrentUser, OrdenExpressIsAdmin, OrdenExpressNavegatePath, OrdenExpressRemoveProductFromVector, OrdenExpressSetProductToVector, OrdenExpressValidateSecurity } from 'orden_express/frameWork/frameWork.js';
import { setDeliveryPointList, setInformationDelivery, setListOfProductsForBeginingOrder, setMessageSaveOrderState, setSelectClient, setSelectDeliveryDate, setSelectDeliveryPoint } from 'orden_express/orders/ordersActions';
import { requestGetDeliveryDates, requestSaveOrderBegining } from 'orden_express/orders/ordersEpic.js';
import { setMessageSaveStateProduct, setOriginRequestList } from 'orden_express/products/productsActions.js';
import { requestGetMeasureUnit, requestGetProductCategory, requestSaveProduct } from 'orden_express/products/productsEpic.js';
import { requestGetUsers, responseGetUsers } from 'orden_express/users/usersEpic.js';
import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Badge, Button, ButtonGroup, Card, CardBody, CardFooter, Col, FormGroup, Input, Row, UncontrolledTooltip } from 'reactstrap';
import { bindActionCreators } from 'redux';


class OrderBegining extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      alert: '',
      alertOverAlert: '',
      addToCart: '',
      filterTextSearchProduct: '',
      clienteState: '',
      deliveryPointState: '',
      deliveryDateState: '',
      informationState: '',
    }
    OrdenExpressValidateSecurity(this, false);
  }

  componentDidMount = () => {
    this.props.requestGetDeliveryDates();
    this.getUsers();

    const timeToNewRequest = 10 * 60 * 1000;//minutos * 60segundos * 1000milisegundos son los milisegundos deseados 
    this.interval = setInterval(() => {
      this.props.requestGetDeliveryDates();
    }, timeToNewRequest);

  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.setState({ filterTextSearchProduct: '' })
    }

    if (this.props.ordersReducerState.messageSaveOrderState !== prevProps.ordersReducerState.messageSaveOrderState) {
      this.processMessageState(this.props.ordersReducerState.messageSaveOrderState);
    }
  }

  closeAddtoCart = () => {
    this.setState({ addToCart: '' });
  }

  nameOfFieldTextSearchCategoryFilter = (pValue) => {
    if (pValue) {
      return pValue;
    }
    return '';
  }

  applyFilters = (pContent) => {
    var filter = this.state.filterTextSearchProduct.toUpperCase();
    var result = [];
    var pos=0;
    var length=pContent.length;
    while(pos<length){
      var pProduct=pContent[pos];
      var localText =
        (pProduct.name +
          pProduct.code +
          pProduct.information +
          pProduct.nameCategory +
          pProduct.nameMeasureUnit +
          pProduct.quantityRequested).toUpperCase();
      if (localText.includes(filter)) {
        result.push(pProduct);
      }
      pos++;
    }
    /*pContent.map((pProduct) => {
      var localText =
        (pProduct.name +
          pProduct.code +
          pProduct.information +
          pProduct.nameCategory +
          pProduct.nameMeasureUnit +
          pProduct.quantityRequested).toUpperCase();
      if (localText.includes(filter)) {
        result.push(pProduct);
      }
    });*/
    return result;
  }

  deleteProductConfirmed = (pData) => {
    var newListOfProducts = OrdenExpressRemoveProductFromVector(this.props.ordersReducerState, 'listOfProductsForBeginingOrder', pData.product.id);
    this.props.setListOfProductsForBeginingOrder(newListOfProducts);
  }

  messageDeleteProductList = (pProduct, pIndex) => {
    FrameWorkMessageAceptCancel(
      this,
      'Borrar ' + pProduct.name,
      '¿Desea borrar el producto seleccionado?',
      this.deleteProductConfirmed,
      null,
      { product: pProduct, index: pIndex },
      null,
      'alert'
    );
  }

  messageCleanData = () => {
    FrameWorkMessageAceptCancel(
      this,
      'Limpiar datos',
      'Esta acción elimina todos los productos de la solicitud actual',
      this.cleanDataConfirmed,
      null,
      null,
      null
    );
  }

  newAddtoCart = (pProduct, pValue) => {
    console.log("--pProduct " + JSON.stringify(pProduct));
    console.log("--pValue " + JSON.stringify(pValue));
    pValue = parseInt(pValue, 10);
    if (isNaN(pValue)) {
      pValue = '';
    }
    var localProduct = pProduct;
    localProduct['quantityRequested'] = pValue;
    localProduct['quantityShipped'] = pValue;
    console.log("--pProduct " + JSON.stringify(localProduct));
    var newListOfProducts = OrdenExpressSetProductToVector(this.props.ordersReducerState, 'listOfProductsForBeginingOrder', localProduct);
    this.props.setListOfProductsForBeginingOrder(newListOfProducts);
  }

  renderFilters = () => {
    return (
      <Row className='framework-v-center'>
        <Col xs='auto'>
          <b>Filtros</b>
        </Col>
        <Col>
          <FormGroup >
            <Input
              className='ml-1 mt-2 mr-0'
              type='text'
              placeholder='Buscar'
              id='idfilterTextSearchProduct'
              value={this.state.filterTextSearchProduct}
              onChange={(newtext) => { this.setState({ filterTextSearchProduct: newtext.target.value }) }}
            />
          </FormGroup>
        </Col>
      </Row>
    )
  }

  renderFormClient = () => {
    let {
      clientState,
      deliveryPointState,
      deliveryDateState,
      informationState,
    } = this.state;
    return (
      <div>
        <Card>
          <CardBody>

            <FormGroup className={`has-label ${clientState}`}>
              <label>Cliente *</label>
              <Select
                className={`react-select ${clientState === 'has-danger' ? 'bg-danger-drop-down' : ''}`}
                classNamePrefix='react-select'
                name='client'
                id='idSelectedClient'
                key='keySelectedClient'
                placeholder='Seleccione el cliente'
                value={this.getUserSelected()}
                options={this.getUserList()}
                onChange={value => { this.changeUserSelected(value) }}
              />
              {this.clientState === 'has-danger' ? (
                <label className='error'>
                  {'Seleccione el cliente'}
                </label>
              ) : null}
            </FormGroup>

            <FormGroup className={`has-label ${deliveryPointState}`}>
              <label>Punto de entrega *</label>
              <Select
                className={`react-select ${deliveryPointState === 'has-danger' ? 'bg-danger-drop-down' : ''}`}
                classNamePrefix='react-select'
                name='deliveryPoint'
                id='idSelectedDeliveryPoint'
                key='keySelectedDeliveryPoint'
                placeholder='Seleccione el punto de entrega'
                value={this.getDeliveryPointSelected()}
                options={this.getDeliveryPointList()}
                onChange={value => { this.changeDeliveryPointSelected(value); }}
              />
              {this.state.deliveryPointState === 'has-danger' ? (
                <label className='error'>
                  {'Seleccione el punto de entrega'}
                </label>
              ) : null}
            </FormGroup>

            <FormGroup className={`has-label ${deliveryDateState}`}>
              <label>Fecha de despacho *</label>
              <Select
                className={`react-select ${deliveryDateState === 'has-danger' ? 'bg-danger-drop-down' : ''}`}
                classNamePrefix='react-select'
                name='deliveryDate'
                id='idSelectedDeliveryDate'
                key='keySelectedDeliveryDate'
                placeholder='Seleccione la fecha de despacho'
                value={this.getDeliveryDateSelected()}
                options={this.getdeliveryDateList()}
                onChange={value => { this.changeDeliveryDateSelected(value) }}
              />
              {this.state.deliveryDateState === 'has-danger' ? (
                <label className='error'>
                  {'Seleccione la fecha de despacho'}
                </label>
              ) : null}
            </FormGroup>

            <FormGroup className={`has-label ${informationState}`}>
              <label>Información</label>
              <Input
                className='textarea'
                name='information'
                type='textarea'
                maxLength='300'
                cols='80'
                rows='4'
                value={this.props.ordersReducerState.informationDelivery}
                onChange={e => { this.changeInformationDelivery(e.target.value) }}
              />
              {this.state.informationState === 'has-danger' ? (
                <label className='error'>
                  {'Ingrese la información adicional que requiera'}
                </label>
              ) : null}
            </FormGroup>

            <div className='category form-category'>
              * Campos obligatorios
              </div>

          </CardBody>

          <CardFooter className='text-right'>
            {this.renderFooterButtons()}
          </CardFooter>
        </Card>

      </div>
    );
  }

  renderButtonNewProduct = () => {
    return (
      <Button
        color={FrameWorkGetPrimaryColorButton()}
        className='btn-round mb-0 mt-1 ml-6'
        onClick={() => {
          OrdenExpressNavegatePath(this, 'products?isFromMakeOrder=true');
        }
        }
        style={{ width: 145 }}
      >
        <i className='icon-big nc-icon nc-box text-white' />
        {'+ producto'}
      </Button>
    );
  }

  renderheaderButtons = () => {
    return (
      <div className='text-right mt-3'>
        <Button
          color={FrameWorkGetSecundaryColorButton()}
          className='btn-round mb-0 mt-1 ml-6'
          onClick={() => {
            this.messageCleanData();
          }
          }
          style={{ width: 145 }}
        >
          <i className='icon-big nc-icon nc-bullet-list-67 text-white' />
          {'Limpiar'}
        </Button>
        {this.renderButtonNewProduct()}
      </div>
    )
  }

  renderDeleteButtonProduct = (pProduct, pIndex) => {
    return (
      <div className='mt-0 mb-0'>
        <Button
          className='btn-icon btn-round mt-0 mb-0'
          color={FrameWorkGetPrimaryColorButton()}
          id={`deleteProduct${pIndex}`}
          type='button'
          outline
          size='lg'

          disabled={pProduct.active !== 1 ? true : false}
          onClick={value => {
            this.messageDeleteProductList(pProduct, pIndex);
          }}
        >
          <i className='fa fa-trash' />
        </Button>
        <UncontrolledTooltip
          delay={0}
          target={`deleteProduct${pIndex}`}
        >
          Borrar producto
          </UncontrolledTooltip>
      </div>
    )
  }

  renderQuantityProductChange = (pProduct, pActualValue) => {
    return (
      <Input
        placeholder='Cantidad'
        type='number'
        style={{ width: 120 }}
        value={pActualValue}
        onChange={(event) => {
          if (event.target.value !== '') {
            if (pProduct.quantityAvailable <= event.target.value) {
              if (event.target.value === 0) {
                event.target.value = 1;
              } else if (event.target.value < 0) {
                event.target.value = Math.abs(event.target.value);
              }
            } else {
              event.target.value = pProduct.quantityAvailable;
            }
            this.newAddtoCart(pProduct, event.target.value);
          }
        }}
      />
    )
  }

  renderButtonChangeQuantity = (pProduct, pActualValue) => {
    pActualValue = parseInt(pActualValue, 10);
    if (isNaN(pActualValue)) {
      pActualValue = 0;
    }
    return (
      <ButtonGroup className='btn-group-sm mt-1 mb-0'>
        <Button
          className='btn-round mt-0 mb-0'
          color='default'
          outline
          onClick={event => {
            var localValue = pActualValue;
            localValue -= 1;
            if (localValue >= pProduct.quantityAvailable) {
              if (localValue === 0) {
                localValue = 1;
              } else if (localValue < 0) {
                localValue = Math.abs(localValue);
              }
              this.newAddtoCart(pProduct, localValue);
            }
          }}
        >
          <i className='nc-icon nc-simple-delete' />
        </Button>
        <Button
          className='btn-round mt-0 mb-0'
          color='default'
          outline
          onClick={event => {
            var localValue = pActualValue;
            localValue += 1;
            if (localValue === 0) {
              localValue = 1;
            } else if (localValue < 0) {
              localValue = Math.abs(localValue);
            }
            this.newAddtoCart(pProduct, localValue);
          }}
        >
          <i className='nc-icon nc-simple-add' />
        </Button>
      </ButtonGroup>
    )
  }

  /************************************************************ */

  getUsers = () => {
    if (OrdenExpressIsAdmin(this)) {
      this.props.requestGetUsers();
    } else {
      var localUser = OrdenExpressGetCurrentUser(this);
      var dataLocaluser = ANSWER_MESSAGE(false, 'Usuario actual del sistema', {}, [localUser]);
      this.props.responseGetUsers(dataLocaluser);

      try {
        this.changeUserSelected({ value: localUser, label: localUser.name });
        var pos = 0;
        var lengthDeliveryPonits = localUser.deliveryPoints.length;
        var asigned = false;
        var localActiveDeliveryPoints = [];
        while (pos < lengthDeliveryPonits) {
          if (localUser.deliveryPoints[pos].active === 1) {
            localActiveDeliveryPoints.push(localUser.deliveryPoints[pos]);
            if (!asigned) {
              this.changeDeliveryPointSelected({ value: localUser.deliveryPoints[pos], lable: localUser.deliveryPoints[pos].name });
            }
            asigned = true;
          }
          pos++;
        }
        this.setDeliveryPointsList(localActiveDeliveryPoints);
      } catch (__) { }
    }
  }

  cleanDataConfirmed = () => {
    this.props.setListOfProductsForBeginingOrder([]);
    this.changeDeliveryDateSelected({ value: '', label: '' })
    this.changeUserSelected({ value: '', label: '' });

    this.changeDeliveryPointSelected({ value: '', label: '' });
    this.props.setDeliveryPointList([]);
    this.props.setInformationDelivery('');
    this.getUsers();
  }

  processMessageState = (pStateForMessage) => {
    switch (pStateForMessage) {
      case 1://procesando solicitud
        FrameWorkSimpleMessageState(this, 'Grabando', 'Su solicitud está en proceso ...');
        break;
      case 2:
        FrameWorkMessageSuccessAlert(this, 'Correcto!', 'Los datos fueron correctamente almacenados', this.succesSaving, this.succesSaving);
        break;
      case 3:
        var localMessageError = this.props.ordersReducerState.responseSaveOrderBegining;
        FrameWorkMessageErrorAlert(this, 'Error :(', localMessageError.message);
        console.error(localMessageError)
        break;
      default:
        FrameWorkHideAlert(this);
        this.props.setMessageSaveOrderState(0);
        break;
    }
  }

  succesSaving = () => {
    this.cleanDataConfirmed();
  }

  saveOrderProductsConfirmed = () => {
    this.props.setMessageSaveOrderState(1);
    var info = {
      user: this.props.ordersReducerState.selectClient.value,
      deliveryPoint: this.props.ordersReducerState.selectDeliveryPoint.value,
      //********************************************/
      //deliveryDate: this.props.ordersReducerState.selectDeliveryDate.value, //OJO SE USA INTERNAMENTE EL NOMBRE DE DELIVERYDATE, PERO EN REALIDAD ES LA FECHA DE DESPACHO*************
      //********************************************/
      dispatchDate: this.props.ordersReducerState.selectDeliveryDate.value,
      information: this.props.ordersReducerState.informationDelivery,
      products: this.props.ordersReducerState.listOfProductsForBeginingOrder,
    };
    this.props.requestSaveOrderBegining(info);
  }

  saveOrderBegining = () => {
    var saveData = true;
    if (saveData && !this.verifyLisOfProducts()) {
      FrameWorkMessageErrorAlert(this, 'No hay productos', 'Debe seleccionar un producto!');
      saveData = false;
    }
    if (!this.verifyData()) {
      FrameWorkMessageErrorAlert(this, 'Faltan datos', 'Debe ingresar todos los datos solicitados');
      saveData = false;
    }
    if (saveData) {
      this.messageSaveProductList();
    }
  }

  messageSaveProductList = () => {
    FrameWorkMessageAceptCancel(
      this,
      'Grabar solicitud',
      '¿Desea enviar su solicitud? Recuerde que después de este proceso no podrá modificarla',
      this.saveOrderProductsConfirmed,
      null,
      null,
      null,
      'alert'
    );
  }
  /**
   * Verifica que exista al menos un producto ingresado en el listado para solicitarlo.
   */
  verifyLisOfProducts = () => {
    var result = true;
    try {
      if (this.props.ordersReducerState.listOfProductsForBeginingOrder.length < 1) {
        result = false;
      }
    } catch (__) {
      result = false;
    }
    return result;
  }
  /**
   * Valida los campos obligatorios y ayuda a determinar
   * en ellos con un color o etiqueta visual para que el 
   * usuario los identifique
   */
  verifyData = () => {

    var dataIsCompleted = FrameWorkChange(this, this.getUserSelected().label, 'client', 'have-content', '1');
    dataIsCompleted = dataIsCompleted && FrameWorkChange(this, this.getDeliveryPointSelected().label, 'deliveryPoint', 'have-content', '1');
    dataIsCompleted = dataIsCompleted && FrameWorkChange(this, this.getDeliveryDateSelected().label, 'deliveryDate', 'have-content', '1');

    return dataIsCompleted;
    /*
    //var dataIsCompleted = true;
    const listValidation = [
      'clientState',
      'deliveryPointState',
      'deliveryDateState',
    ];
    listValidation.map((item, index) => {
      if (FrameWorkVerifyDataIsCompleted(this.state[item])) {
        dataIsCompleted = false;
        this.setState({ [item]: 'has-danger' });
      }
    });
    return dataIsCompleted;*/
  };

  renderFooterButtons = () => {
    return (
      <div className='text-right'>
        <Button
          className='btn-icon btn-round mt-0'
          color={FrameWorkGetPrimaryColorButton()}
          id='buttonSaveOrderBegining'
          type='button'
          outline
          size='lg'
          onClick={value => {
            this.saveOrderBegining();
          }}
        >
          <i className='fa fa-save' />
        </Button>
        <UncontrolledTooltip
          delay={0}
          target='buttonSaveOrderBegining'
        >
          Guardar solicitud
        </UncontrolledTooltip>
      </div>
    )
  }

  getUserSelected = () => {
    var result = { value: '', label: '' };
    try {
      if (this.props.ordersReducerState.selectClient.value)
        result = this.props.ordersReducerState.selectClient;
    } catch (__) { }
    return result;
  }

  getUserList = () => {
    var listOfusers = [];
    var listActiveUsers = [];
    try {
      listOfusers = this.props.userReducerState.responseGetUsers.result || [];
      var pos = 0;
      var lengthOfList = listOfusers.length;
      while (pos < lengthOfList) {
        if (listOfusers[pos].active === 1) {
          listActiveUsers.push(listOfusers[pos]);
        }
        pos++;
      }
    } catch (_) { }

    return (
      listActiveUsers.map((itemUser) => {
        return (
          { value: itemUser, label: itemUser.name }
        )
      })
    );
  }

  changeUserSelected = (value) => {
    try {
      this.props.setSelectClient(value);
      FrameWorkChange(this, value.label, 'client', 'have-content', '1');
      const deliveryPoints = value.value.deliveryPoints || [];
      this.setDeliveryPointsList(deliveryPoints);
    } catch (__) { }
  }

  getDeliveryPointSelected = () => {
    var result = { value: '', label: '' };
    /*try {
      var localListDeliveryPoints = this.props.ordersReducerState.setDeliveryPointList || [];
    } catch (__) { }*/

    try {
      if (this.props.ordersReducerState.selectDeliveryPoint.value)
        result = this.props.ordersReducerState.selectDeliveryPoint;
    } catch (__) { }
    return result;
  }

  setDeliveryPointsList = (pList) => {
    this.props.setDeliveryPointList(pList);
    if (pList.length === 1) {
      if (pList[0].active === 1) {
        this.changeDeliveryPointSelected({ value: pList[0], label: pList[0].name });
        return
      }
    }
    this.changeDeliveryPointSelected({ value: '', label: '' });
  }

  getDeliveryPointList = () => {
    var localListOfdeliveryPoints = [];
    var localLisActiveDeliveryPoints = [];
    try {
      localListOfdeliveryPoints = this.props.ordersReducerState.setDeliveryPointList || [];
      var pos = 0;
      var lengthList = localListOfdeliveryPoints.length;
      while (pos < lengthList) {
        if (localListOfdeliveryPoints[pos].active === 1) {
          localLisActiveDeliveryPoints.push(localListOfdeliveryPoints[pos]);
        }
        pos++;
      }
    } catch (__) { }

    return (
      localLisActiveDeliveryPoints.map((itemDeliveryPoint) => {
        return (
          { value: itemDeliveryPoint, label: itemDeliveryPoint.name }
        )
      })
    );
  }

  changeDeliveryPointSelected = (value) => {
    this.props.setSelectDeliveryPoint(value);
    FrameWorkChange(this, value.label, 'deliveryPoint', 'have-content', '1');
  }


  getDeliveryDateSelected = () => {
    var result = { value: '', label: '' };
    try {
      if (this.props.ordersReducerState.selectDeliveryDate.value)
        return this.props.ordersReducerState.selectDeliveryDate;
    } catch (__) { }
    return result;
  }

  changeDeliveryDateSelected = (value) => {
    this.props.setSelectDeliveryDate(value);
    FrameWorkChange(this, value.label, 'deliveryDate', 'have-content', '1');
  }

  getdeliveryDateList = () => {
    var listOfDeliveryDates = this.props.ordersReducerState.responseGetDeliveryDates.result || [];
    return (
      listOfDeliveryDates.map((itemDeliveryDate) => {
        return (
          { value: itemDeliveryDate.timeStamp, label: itemDeliveryDate.deliveryDate }
        )
      })
    );
  }

  changeInformationDelivery = (value) => {
    this.props.setInformationDelivery(value);
    FrameWorkChange(this, value, 'information', 'have-content', 1)
  }
  /************************************************************ */

  render() {

    var localProducts = [];
    try {
      localProducts = this.applyFilters(this.props.ordersReducerState.listOfProductsForBeginingOrder);
    } catch (_) { }

    return (
      <div className='content mt-5 mb-0'>
        {this.state.alert}
        {this.state.alertOverAlert}
        <div className='framework-flexcontainer'>
          <div>
            <h4>{'Solicitud'}</h4>
          </div>
          <div className='text-right framework-flex-rigth'>
            {this.renderheaderButtons()}
          </div>
        </div>
        <div>
          <Card className='mt-1 mb-1'>
            <CardBody>
              {this.renderFilters()}
            </CardBody>
          </Card>
        </div>
        {
          localProducts.map((itemProduct, indexproduct) => {
            return (
              <Card className={`mt-0 mb-1 ${indexproduct % 2 === 0 ? 'bg-gray' : 'bg-white'}`} key={`idRowTableProducts'${indexproduct}`}>
                <CardBody>
                  <Row>
                    <Col xs='auto' className='text-center'>
                      {this.renderDeleteButtonProduct(itemProduct, indexproduct)}
                      {this.renderButtonChangeQuantity(itemProduct, itemProduct.quantityRequested)}
                    </Col>
                    <Col>
                      <div className='framework-flexcontainer'>
                        <b>
                          {itemProduct.name}{' ('}{itemProduct.nameMeasureUnit}{')'}
                        </b>
                        <Badge className='framework-flex-rigth' style={{ width: 80 }} color={itemProduct.active === 1 || itemProduct.active === true ? 'success' : 'danger'} pill>
                          {itemProduct.active === 1 || itemProduct.active === true ? 'Activo' : 'Inactivo'}
                        </Badge>
                      </div>
                      <div className='d-inline-block'>
                        {this.renderQuantityProductChange(itemProduct, itemProduct.quantityRequested)}
                      </div>
                      <div className='framework-flexcontainer'>
                        <div className='d-inline-block'>


                          {' '}
                          {'Código: '}
                          {itemProduct.code}
                          {' '}
                          {'Cantidad mínima: '}
                          {itemProduct.quantityAvailable}
                          {' '}
                          {itemProduct.nameMeasureUnit}
                          {' '}
                          {'Categoría: '}
                          {itemProduct.nameCategory}

                        </div>
                        <div className='framework-flex-rigth mr-1'>
                          <span id={`moreInformation${indexproduct}`}>
                            <i className='fa fa-ellipsis-v mr-0' />
                          </span>
                          <UncontrolledTooltip
                            delay={0}
                            target={`moreInformation${indexproduct}`}
                          >
                            {itemProduct.information}
                          </UncontrolledTooltip>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )
          })
        }
        {this.renderFormClient()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userReducerState: state.userReducerState,
    productsReducerState: state.productsReducerState,
    ordersReducerState: state.ordersReducerState,
    loginReducerState: state.loginReducerState,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setOriginRequestList: (originRequestListsetOriginRequestList) => dispatch(setOriginRequestList(originRequestListsetOriginRequestList)),
    setMessageSaveStateProduct: messageSaveStateProduct => dispatch(setMessageSaveStateProduct(messageSaveStateProduct)),
    setSelectClient: (selectClient) => dispatch(setSelectClient(selectClient)),
    setSelectDeliveryPoint: (selectDeliveryPoint) => dispatch(setSelectDeliveryPoint(selectDeliveryPoint)),
    setSelectDeliveryDate: (selectDeliveryDate) => dispatch(setSelectDeliveryDate(selectDeliveryDate)),
    setInformationDelivery: (informationDelivery) => dispatch(setInformationDelivery(informationDelivery)),
    setMessageSaveOrderState: (messageSaveOrderState) => dispatch(setMessageSaveOrderState(messageSaveOrderState)),
    responseGetUsers: (dataUser) => dispatch(responseGetUsers(dataUser)),
    setDeliveryPointList: (dataListDeliveryPoints) => dispatch(setDeliveryPointList(dataListDeliveryPoints)),

    requestGetProductCategory: () => bindActionCreators(dispatch(requestGetProductCategory()), dispatch),
    requestGetMeasureUnit: () => bindActionCreators(dispatch(requestGetMeasureUnit()), dispatch),
    requestSaveProduct: dataProduct => bindActionCreators(dispatch(requestSaveProduct(dataProduct)), dispatch),
    requestGetUsers: () => bindActionCreators(dispatch(requestGetUsers()), dispatch),
    requestGetDeliveryDates: () => bindActionCreators(dispatch(requestGetDeliveryDates()), dispatch),
    requestSaveOrderBegining: (ContentRequestSaveOrderBegining) => bindActionCreators(dispatch(requestSaveOrderBegining(ContentRequestSaveOrderBegining))),
    setListOfProductsForBeginingOrder: (listOfProductsForBeginingOrder) => dispatch(setListOfProductsForBeginingOrder(listOfProductsForBeginingOrder)),


  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderBegining);